import DOMPurify from 'dompurify'

/**
 * The following two lists represent all the HTML tags that
 * we want DOMPurify to allow in the final rendered output.
 *
 * They are split into two lists so that it is clear which elements
 * are svg specific, and which are general HTML nodes e.g. `div` or `p`.
 *
 * This is done mainly for organizational purposes, but also to make it somewhat
 * easier to see which tags belong to which domain (svg vs general markup).
 */

const SVG_TAGS = [
  'a',
  'animate',
  'animateColor',
  'animateMotion',
  'animateTransform',
  'circle',
  'defs',
  'desc',
  'ellipse',
  'font-face',
  'font-face-name',
  'font-face-src',
  'foreignObject',
  'g',
  'glyph',
  'hkern',
  'line',
  'linearGradient',
  'marker',
  'metadata',
  'missing-glyph',
  'mpath',
  'path',
  'polygon',
  'polyline',
  'radialGradient',
  'rect',
  'set',
  'stop',
  'svg',
  'switch',
  'text',
  'title',
  'tspan',
  'use',
  'altglyph',
  'altglyphdef',
  'altglyphitem',
  'animatecolor',
  'animatemotion',
  'animatetransform',
  'clippath',
  'filter',
  'font',
  'glyphref',
  'image',
  'lineargradient',
  'mask',
  'pattern',
  'radialgradient',
  'style',
  'symbol',
  'textpath',
  'tref',
  'view',
  'vkern',
]

const HTML_TAGS = [
  'body',
  'b',
  'blockquote',
  'br',
  'code',
  'dd',
  'del',
  'div',
  'dl',
  'dt',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'h7',
  'h8',
  'hr',
  'i',
  'img',
  'ins',
  'kbd',
  'li',
  'ol',
  'p',
  'pre',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'span',
  'strike',
  'strong',
  'sub',
  'sup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
  'tt',
  'ul',
  'var',
]

const ALLOWED_TAGS = [...HTML_TAGS, ...SVG_TAGS]

function sanitizeContent(content = '') {
  const sanitized = DOMPurify.sanitize(content, {
    ALLOWED_TAGS,
    RETURN_DOM_FRAGMENT: true,
  })
  return sanitized
}

async function sanitizeNotebook(): Promise<DocumentFragment> {
  const content = window.NOTEBOOK_DATA?.html ?? ''
  const sanitized = sanitizeContent(content)
  window.NOTEBOOK_DATA = null

  return sanitized
}

export {sanitizeContent}

export default sanitizeNotebook
